import { CheckCircle2, AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import type { ImportStatus } from "@/hooks/useSpyImport";

interface ImportProgressProps {
  loading: boolean;
  status: ImportStatus;
  progress: number;
}

export const ImportProgress = ({
  loading,
  status,
  progress,
}: ImportProgressProps) => {
  if (!loading && status.type === "idle") {
    return null;
  }

  return (
    <Card className="border-primary/20 bg-primary/5">
      <CardContent className="p-6 space-y-4">
        <div className="flex items-center gap-3">
          {loading && (
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary" />
          )}
          {!loading && status.type === "success" && (
            <CheckCircle2 className="h-5 w-5 signal-text-positive" />
          )}
          {!loading && status.type === "error" && (
            <AlertCircle className="h-5 w-5 signal-text-negative" />
          )}
          <span className="font-medium text-sm">{status.message}</span>
        </div>
        {loading && (
          <div className="space-y-1">
            <Progress value={progress} className="h-2" />
            <p className="text-xs text-muted-foreground text-right">
              {progress}%
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
